export default "__VITE_ASSET__BCqb1v1k__"